<template>
  <div class="dropdown">
    <button class="btn-regular" :class="{teal : isSet, secondary : !isSet}" @click.stop="toggledDropdown">MORE FILTER</button>
   
    <media :query="{maxWidth: 769}">
        <div v-if="isShown">
        <modal v-if="isShown" :title="title" @modal-close="closeDropdown">
        <template slot="content">
            <div v-for="(dropdown, index) in list" :key="index">  
                <div class="wrapper_content" v-if="expand[index]">
                    <div class="wrapper" @click.stop="toogleExpand(index)">
                    <span>{{dropdown.title}}</span>
                    <i class="icon-chevronup"></i>
                    </div>
                    <div v-if="dropdown.type ==='checkbox'"> 
                        <div class="dropdown__menu" @click.stop="isShown = true">
                            <div class="dropdown__menu__wrapper">
                            <multiple-checkbox
                                :value="false"
                                :options="dropdown.list"
                                :styleClass="`dropdown__menu__wrapper__sub__item`"
                                :styleWrapperClass="`dropdown__menu__wrapper__sub`"
                            />
                            </div>
                            <div class="dropdown__menu__footer">
                            <span @click.stop="reset" class="dropdown__menu__footer__reset">Reset</span>
                            <span @click.stop="apply" class="dropdown__menu__footer__apply">Apply</span>
                            </div>
                        </div>  
                    </div>
                    <div v-else>
                        <div class="dropdown__menu" @click.stop="isShown = true">
                            <div class="dropdown__menu__wrapper">
                                <ul class="dropdown__menu__wrapper__sub">
                                <li v-for="item in dropdown.list" :key="item.id" @click.stop="select(item)"
                                class="dropdown__menu__wrapper__sub__item" :class="{selected: item.id == selected}">
                                <span>{{ item.label }}</span>
                                </li>
                                </ul>
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="wrapper_content" v-else>
                    <div class="wrapper" @click.stop="toogleExpand(index)">
                    <span>{{dropdown.title}}</span>
                    <i class="icon-chevrondown"></i>
                    </div>
                </div>
            </div>
        </template>
        </modal>
        </div>
    </media>
  </div>
</template>

<script>
import Vue from 'vue'
import Media from 'vue-media'
import Modal from '@/components/Modal'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import MultipleCheckbox from '@/components/Form/MultipleCheckbox'

export default {
  name: 'adx-dropdown-list',
  components: {
    'media': Media,
    'modal': Modal,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-sort': DropdownSort,
    'multiple-checkbox': MultipleCheckbox,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    title: {
       required: false,
       default: 'More Filter'
    }
  },
  data() {
    return {
      isShown: false,
      isSet: false,
      selected: null,
      selectedValue:null,
      labelDropdown: '',
      firstLabelDropdown: '',
      expand: []
    }
  },
  watch: {
    labelButton() {
      this.labelDropdown = this.labelButton
    },
    valueDisplay() {
      if (!this.valueDisplay) {
        this.labelDropdown = this.firstLabelDropdown
        this.isSet = false
        this.selected = null
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
    this.labelDropdown = this.labelButton
    this.firstLabelDropdown = this.labelButton
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.closeDropdown()
      }
    })
    this.initialExpandValue()
  },
  updated() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
  },
  methods: {
    initialExpandValue(){
        for(let i = 0; i<this.list.length;i++){
            this.expand.push(false)
        }
    },
    toogleExpand(index){
        let val = this.expand[index]
        this.$set(this.expand, index, !val)
    },
    toggledDropdown(sender) {
      Vue.$broker.$emit("app-click", this)
      this.isShown = !this.isShown
    },
    selectedClick(){

    },
    closeDropdown(sender) {
      if (sender === this) {
        return
      }
      this.isShown = false
    },
    select(item) {
      // this.$emit('selected', item)
      if (this.selected == item.id) {
        this.selected = null
        this.selectedValue = null
        this.labelDropdown = this.firstLabelDropdown
        this.isSet = false
      } else {
        this.labelDropdown = item.label
        this.selected = item.id
        this.selectedValue = item.value
        this.isSet = true
      }
      let label =  this.labelDropdown === this.firstLabelDropdown ? null : this.labelDropdown

      this.$emit('selected', {id:item.id, value:this.selectedValue, label:this.firstLabelDropdown})
      this.closeDropdown()
    },
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
.wrapper {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid grey;
    border-top: 1px solid grey;
    padding: 10px 0;
}
.dropdown__menu__footer{
    display: flex;
    justify-content: space-between;
}
</style>